import { UserButton as ClerkUserButton, useUser } from '@clerk/clerk-react'

function UserButton() {
  const { user } = useUser()
  
  return (
    <div className="flex items-center space-x-3">
      {user && (
        <div className="hidden sm:block text-right">
          <p className="text-sm font-medium text-gray-900">
            {user.fullName || user.primaryEmailAddress?.emailAddress}
          </p>
          <p className="text-xs text-gray-500">
            Account
          </p>
        </div>
      )}
      <ClerkUserButton 
        afterSignOutUrl="/sign-in"
        appearance={{
          elements: {
            avatarBox: 'w-10 h-10',
          },
        }}
      />
    </div>
  )
}

export default UserButton

